import React from "react";
import { variables as breakpoints } from "@xo-union/tk-ui-breakpoints";
import colors from "@xo-union/tk-ui-colors/lib/variables.css";
var styles = function styles() {
  return "\n.Union__header-nav-pagelet-placeholder {\n  background-color: ".concat(colors.varBackgroundLight, ";\n  border-bottom: 1px solid #ccc;\n  display: flex;\n  height: 60px;\n}\n\n@media (").concat(breakpoints.inDesktop, ") {\n  .Union__header-nav-pagelet-placeholder {\n    height: 120px;\n  }\n}\n");
};
export default (function () {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: styles()
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "Union__header-nav-pagelet-placeholder"
  }));
});